import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { utc: String, format: { type: String, default: "datetime" } }

  connect() {
    const date = new Date(this.utcValue)
    if (isNaN(date.getTime())) return

    const tz = this.formatTZ(date)

    switch (this.formatValue) {
      case "date":
        this.element.textContent = this.fmtDate(date) + " " + tz
        break
      case "short":
        this.element.textContent = this.fmtShort(date) + " " + tz
        break
      case "ago":
        this.element.textContent = this.fmtAgo(date)
        break
      default:
        this.element.textContent = this.fmtDateTime(date) + " " + tz
    }
  }

  fmtDate(d) {
    return d.getFullYear() + "-" + this.pad(d.getMonth() + 1) + "-" + this.pad(d.getDate())
  }

  fmtDateTime(d) {
    return this.fmtDate(d) + " " + this.pad(d.getHours()) + ":" + this.pad(d.getMinutes())
  }

  fmtShort(d) {
    return this.pad(d.getMonth() + 1) + "/" + this.pad(d.getDate()) + " " + this.pad(d.getHours()) + ":" + this.pad(d.getMinutes())
  }

  fmtAgo(d) {
    const seconds = Math.floor((Date.now() - d.getTime()) / 1000)
    if (seconds < 60) return seconds + "s"
    const minutes = Math.floor(seconds / 60)
    if (minutes < 60) return minutes + "m"
    const hours = Math.floor(minutes / 60)
    if (hours < 24) return hours + "h"
    const days = Math.floor(hours / 24)
    return days + "d"
  }

  formatTZ(d) {
    const offset = -d.getTimezoneOffset()
    const sign = offset >= 0 ? "+" : "-"
    const h = String(Math.floor(Math.abs(offset) / 60)).padStart(2, "0")
    const m = String(Math.abs(offset) % 60).padStart(2, "0")
    return sign + h + ":" + m
  }

  pad(n) { return String(n).padStart(2, "0") }
}
